import { render, staticRenderFns } from "./BizEndorseList.vue?vue&type=template&id=6c51eb44&scoped=true&"
import script from "./BizEndorseList.vue?vue&type=script&lang=js&"
export * from "./BizEndorseList.vue?vue&type=script&lang=js&"
import style0 from "./BizEndorseList.vue?vue&type=style&index=0&id=6c51eb44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51eb44",
  null
  
)

export default component.exports